import React from "react";
import ModalCloseIcon from "../../shared/Modal/CloseIcon";

const ModalHeader = ({
  title,
  toggleModal,
  centeredTitle = true
}) => (
  <div className="mia_modal_header">
    <div className="d-flex justify-content-between align-items-center">
      {centeredTitle && <span />}
      {title && (
        <div className="mia_modal_title">
          {title}
        </div>
      )}
      <ModalCloseIcon toggleModal={toggleModal} />
    </div>
  </div>
);

export default ModalHeader;
